<template>
  <b-modal
    id="bank-account-group"
    title="Conta bancária"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
    size="xl"
  >
    <!-- Title -->
    <div class="row">
      <div class="col">
        <h2>Reembolsos</h2>
      </div>
    </div>
    <!-- Sub Title -->
    <div class="row">
      <div class="col">
        <h5>Informe os dados de conta para avançar nos reembolos</h5>
      </div>
    </div>
    <!-- Table Header -->
    <div class="row space">
      <div class="col-2">Cartão de crédito: {{quantityInPaymentMethods('CREDIT_CARD')}}</div>
      <div class="col-3">Dois cartões de crédito: {{quantityInPaymentMethods('TWO_CREDIT_CARD')}}</div>
      <div class="col-2">Pix: {{quantityInPaymentMethods('PIX')}}</div>
      <div class="col-2">Paypal: {{quantityInPaymentMethods('PAYPAL')}}</div>
      <div class="col-2">Boleto: {{quantityInPaymentMethods('BOLETO')}}</div>
    </div>  
    <!-- Table Body -->
    <form @submit.prevent="handleSubmit">
      <div v-for="(solicitation, index) in solicitations" :key="solicitation.id">
        <div v-if="solicitation.sale.method === 'BOLETO'" class="row border-row">
          <div class="col-3">
            <!-- Ticket -->
            <div class="row">
              <div class="col">
                <h4>Boleto</h4>
              </div>
            </div>
            <!-- Client Name -->
            <div class="row">
              <div class="col-3">
                <div class="space">{{solicitation.sale.client.name}}</div>
              </div>
            </div>
            <!-- Client E-mail -->
            <div class="row">
              <div class="col-3">
                <div class="space">{{solicitation.sale.client.email}}</div>
              </div>
            </div>
            <!-- Amount -->
            <div class="row">
              <div class="col">
                {{`${
                  Number(solicitation.sale.amount)
                  .toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                }`}}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <!-- Bank Code -->
              <div class="col-4">
                <div class="form-group">
                  <label for="bank_code">Código do banco</label>
                  <input
                    id="bank_code"
                    v-model="solicitation.bank_code"
                    type="text"
                    class="form-control"
                    placeholder="Somente o código"
                    :class="{
                      'is-invalid': submitted && validField(`bank_code${index}`),
                    }"
                    @click="resetErrors"
                  />
                  <div v-if="submitted && !validField(`bank_code${index}`)"
                    class="invalid-feedback"
                  >
                    Número do banco é obrigatório
                  </div>
                </div>
              </div>
              <!-- Account Agency Number -->
              <div class="col-4">
                <div class="form-group">
                  <label for="agency">Agência</label>
                  <input
                    id="agency"
                    v-model="solicitation.agency_number"
                    type="text"
                    name="agency"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && validField(`agency_number${index}`),
                    }"
                    @click="resetErrors"
                  />
                  <div v-if="submitted && validField(`agency_number${index}`)"
                    class="invalid-feedback"
                  >
                    <span v-if="!validField(`agency_number${index}`)">
                      Número da agência é obrigatória.
                    </span>
                  </div>
                </div>
              </div>
              <!-- Account Agency DV -->
              <div class="col-3">
                <div class="form-group">
                  <label for="agency_dv">Dígito verificador</label>
                  <input
                    id="agency_dv"
                    v-model="solicitation.agency_dv"
                    type="text"
                    name="agency_dv"
                    class="form-control"
                    placeholder="Caso precise"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <!-- Account Number -->
              <div class="col-3">
                <div class="form-group">
                  <label for="account_number">Número da conta</label>
                  <input
                    id="account_number"
                    v-model="solicitation.account_number"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && validField(`account_number${index}`),
                    }"
                    @click="resetErrors"
                  />
                  <div v-if="submitted && !validField(`account_number${index}`)"
                    class="invalid-feedback"
                  >
                    Número da conta é obrigatória
                  </div>
                </div>
              </div>
              <!-- Account DV -->
              <div class="col-2">
                <div class="form-group">
                  <label for="account_dv">Dígito verificador</label>
                  <input
                    id="account_dv"
                    v-model="solicitation.account_dv"
                    type="text"
                    class="form-control"
                    placeholder="Caso precise"
                  />
                </div>
              </div>
              <!-- Name of the Account Holder -->
              <div class="col-3">
                <div class="form-group">
                  <label for="name">Titular da conta</label>
                  <input
                    id="name"
                    v-model="solicitation.name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && validField(`name${index}`) }"
                    @click="resetErrors"
                  />
                  <div v-if="submitted && !validField(`name${index}`)"
                    class="invalid-feedback"
                  >
                    Titular da conta é obrigatório
                  </div>
                </div>
              </div>
              <!-- CPF/CNPJ -->
              <div class="col-3">
                <div class="form-group">
                  <label for="document_number">CPF/CNPJ</label>
                  <input
                    id="document_number"
                    :value="solicitation.document_number"
                    @input="onSolicitationDocumentInput(solicitation, $event)"
                    type="text"
                    maxlength="18"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && validField(`document_number${index}`),
                    }"
                    @click="resetErrors"
                  />
                  <div v-if="submitted && !validField(`document_number${index}`)"
                    class="invalid-feedback"
                  >
                    CPF/CNPJ é obrigatório
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="text-right">
        <b-button class="mr-1" variant="danger" @click="hideModal">
          Cancelar
        </b-button>
        <b-button variant="success" @click.prevent="validForm">
          Reembolsar
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { onDocumentInput as handleDocumentInput } from '@src/helpers/documentValidator'

export default {
	name: 'ModalBankAccountGroup',
	props: {
		solicitations: {
			required: true,
			type: Array,
			default: () => []
		},
	},
  data() {
    return {
      account: {
        bank_code: null,
        agency_number: null,
        agency_dv: null,
        account_number: null,
        account_dv: null,
        name: null,
        document_number: null,
      },
      currentPage: 1,
      endIndex: 6,
      perPage: 6,
      startIndex: 1,
      submitted: false
    }
  },
  methods: {
    onSolicitationDocumentInput(solicitation, event) {
      handleDocumentInput(event, (value) => {
        solicitation.document_number = value;
      });
    },
    /**
     * Fires when user submits the form. Validates with vuelidate, if true, sends an event to the parent component to make the request, effecting the refund
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    handleSubmit() {
      this.submitted = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('submit', this.account)
        this.$bvModal.hide('bank-account-group')
      }
    },
    /**
     * Hide modal when user clicks on cancel
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    hideModal() {
      this.submitted = false
      this.account = {}
      this.clearData()
      this.$bvModal.hide('bank-account-group')
    },
    /**
     * Set null solicitations data bank accounts
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    clearData() {
      this.solicitations.forEach(solicitation => {
        solicitation.bank_code = null
        solicitation.agency_number = null
        solicitation.agency_dv = null
        solicitation.account_number = null
        solicitation.account_dv = null
        solicitation.name = null
        solicitation.document_number = null
      })
    },
    /**
     * Validate any fields by passing there names using vuelidate
     * @param field - String
     * @return Boolean
     * @author Sandro Souza
     */
    validField(field) {
      return this.errors.includes(field)
    },
    /**
     * Reset errors if length is diferent than null or undefined
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    resetErrors() {
      if(this.errors.length) this.errors = []
    },
    /**
     * Validate the form. If false, it returns an error message. If true closes the modal and sends an event to the parent component to update the status of selected refund solicitations
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    validForm() {
      this.resetErrors()
      this.submitted = true
      this.solicitations.forEach((element,index) => {
        for (let i in element) {
          if (
            i === 'account_number' ||
            i === 'agency_number' ||
            i === 'bank_code' ||
            i === 'document_number' ||
            i === 'name'
          ) {
            if (!element[i] && element.sale.method === 'BOLETO') {
              this.errors.push(`${i}${index}`)
            }
          }
        }
      })
      if (this.errors.length) {
        return
      }
      this.refundGroup()
    },
    /**
     * Close modal and sends an event to the parent component to update the status of selected refund solicitations
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    refundGroup() {
      this.submitted = false
      this.$emit('refund-group', this.solicitations)
      this.$bvModal.hide('bank-account-group')
    },
    /**
     * Calculates and return quantity of refund solicitations in the payment method passed in the argument
     * @param typeMethods - String
     * @return Number
     * @author Sandro Souza
     */
    quantityInPaymentMethods(typeMethods) {
      let res = 0
      this.solicitations.forEach(solicitation => {
        if (solicitation.sale.method === typeMethods) {
          res += 1
        }
      })
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.border-row {
  border-bottom: 1.5px solid #d3d3d3;
  margin-bottom: 10px;
}

.space {
  margin-bottom: 10px;
}
</style>